import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import 'tailwindcss/tailwind.css';

const images = [
  '/assets/campus/campus-5.jpg',
  '/assets/campus/campus-6.jpg',
  '/assets/campus/campus-7.jpg',
  '/assets/campus/campus-4.jpg',
];

export default function CampusLife() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1,
    );
  };

  return (
    <div className="flex flex-col md:flex-row items-center justify-between bg-[#f9f7f4] py-6 relative">
      <div className="flex-col md:flex-row mx-auto flex justify-between items-center px-4 md:px-8">
        {/* Left Content */}
        <div className="md:w-2/5 space-y-4">
          <div className="flex justify-center md:justify-start">
            <h2 className="text-4xl font-bold text-[#232172] flex border-b-[3px] border-[#2c2087] py-1 text-center md:text-left">
              Beyond the Classroom
            </h2>
          </div>
          <p className="text-gray-700 text-lg pb-8 pr-5">
            At SPSU, campus life is vibrant and diverse. Students engage in a
            wide range of clubs and organizations, from academic societies to
            cultural groups, fostering connections and friendships.
          </p>
        </div>

        {/* Right Image Slider */}
        <div className="w-full md:w-3/5 relative">
          <div className="bg-[#252b71] pl-[20px] clip-hexagon">
            <div className="relative w-full clip-hexagon overflow-hidden">
              <img
                src={images[currentIndex]}
                alt="Campus Life"
                className="w-full h-80 md:h-96 object-cover"
              />
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute top-1/2 left-8 md:left-16 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-lg z-10"
          >
            <ChevronLeft className="text-gray-700" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-lg z-10"
          >
            <ChevronRight className="text-gray-700" />
          </button>
        </div>
      </div>
    </div>
  );
}
